/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useEffect, useState } from 'react'
import Modal from '~/components/Modal'
import { useServiceContext } from '~/root'
import { FsiTags } from '~/components/doc-preview/FsiTags'

interface FsiTagsModalProps {
  fsi: any
  onClose?: () => void
  params?: any
}

const FsiTagsModal: React.FC<FsiTagsModalProps> = ({ fsi, onClose, params }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(true)
  }, [])

  const doClose = (): void => {
    setIsOpen(false)
    if (onClose) {
      onClose()
    }
  }

  return (
    <Modal show={isOpen} handleClose={doClose} title={translate('SETTINGS_PACKAGE_TAGS')}>
      <FsiTags fsi={fsi} params={params} isModal doClose={doClose} />
    </Modal>
  )
}

export default FsiTagsModal
